import { render } from "./Main.vue?vue&type=template&id=1de49f28&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=1de49f28&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=1de49f28&lang=css"
script.render = render
script.__scopeId = "data-v-1de49f28"

export default script